import { rem } from 'polished';
import styled from 'styled-components';

export const Form = styled.form`
  fieldset {
    padding: 0;
    margin: 0;
    border: none;
  }

  div:has(> label) {
    margin-bottom: ${rem(8)};
  }

  div:has(> input) {
    margin-bottom: ${rem(24)};

    &:has(~ .notes) {
      margin-bottom: ${rem(16)};
    }
  }

  .dropdown-container {
    margin-bottom: ${rem(24)};

    &:last-child {
      margin-bottom: 0;
    }

    div:has(> input) {
      margin-bottom: 0;
    }
  }

  label {
    font-weight: 500;
  }

  h3 {
    margin: 0 0 ${rem(12)} 0;
    font-size: ${rem(16)};
    font-weight: 500;
    color: ${({ theme }) => theme.colors.form.field.text};
  }

  .text-loader {
    margin: 0 auto;
  }

  .card.error {
    border: none;

    svg {
      display: none;
    }

    span {
      color: ${({ theme }) => theme.colors.form.error};
      font-weight: normal;
    }
  }

  .ctas {
    list-style: none;
    margin: ${rem(16)} 0 0 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
  }
`;
